import { Injectable } from '@angular/core';
import { DropdownQuestion, EntityQuestion, HiddenQuestion, QuestionBase, TextboxQuestion } from 'core/components/forms';
import { AdaCustomization } from 'core/models/ada-customization';
import { Profile } from 'core/models/agent';
import { ClientsService, LocalesService, ProfileService } from 'core/services';

@Injectable()
export class CustomizationsQuestionsService {
  public loggedUser: Profile;

  constructor(public clients: ClientsService, public locales: LocalesService, public profileService: ProfileService) {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      this.loggedUser = loggedUser;
    });
  }

  getQuestions(customization: AdaCustomization) {
    const questions: QuestionBase<any>[] = [
      this.getClientQuestion(customization),
      new TextboxQuestion({
        class: 'col-2',
        key: 'name',
        label: 'nouns.name',
        value: customization && customization.name ? customization.name : null,
        validators: { required: true },
        order: 2
      }),
      new DropdownQuestion({
        class: 'col-2',
        key: 'languages',
        label: 'nouns.lang',
        placeholder: 'actions.selectLanguage',
        value: customization && customization.languages.length ? customization.languages[0] : null,
        validators: { required: true },
        options: this.locales.getAvailableLocaleOptions(['es', 'en', 'fr', 'de', 'br', 'pt', 'zh', 'ru', 'nl']),
        order: 3
      })
    ];

    if (['root', 'global'].includes(this.loggedUser.roleOptions.scope)) {
      questions.push(
        new DropdownQuestion({
          class: 'col-1',
          key: 'defaultForLanguage',
          label: 'nouns.defaultStructureForLanguage',
          placeholder: 'actions.selectLanguage',
          value: customization && customization.defaultForLanguage ? customization.defaultForLanguage : '',
          options: this.locales.getAvailableLocaleOptions(['es', 'en', 'fr', 'de', 'br', 'pt']),
          order: 6
        })
      );
    }
    return questions;
  }

  getClientQuestion(customization: AdaCustomization): QuestionBase<string> {
    const client = customization ? { id: customization.clientId, name: customization.clientName } : null;
    if (['root', 'global'].includes(this.loggedUser.roleOptions.scope)) {
      return new EntityQuestion({
        key: 'clientId',
        label: 'nouns.client',
        class: 'col-1',
        value: client ? client.id : null,
        entity: client,
        editable: !customization,
        validators: { required: true },
        dataProvider: this.clients,
        disabled: false
      });
    }
    const clientId = client ? client.id : this.loggedUser.clientId;
    return new HiddenQuestion({
      key: 'clientId',
      value: clientId
    });
  }
}
